define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/special-occasion/specialOccasionEventTimeFrameView.tmpl");

    var TimeFrame = require("ui/timeframe/Timeframe");
    var DateUtility = require("utils/DateUtility");
    var ScheduleUtilities = require("utils/ScheduleUtilities");

    var SpecialOccasionEventTimeFrameView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEventTimeFrameView = Marionette.ItemView.extend({
            template: template,
            ui: {
                timeFrameComponentContainer: ".time-frame-component-container"
            },
            uiComponents: {
                timeFrame: {
                    type: TimeFrame,
                    options: {
                        vent: "view.channel",
                        container: "view.ui.timeFrameComponentContainer",
                        isEndDateCheckboxHidden: true,
                        isLimitEndDatePicker: false,
                        isLimitStartDatePicker: false,
                        isLimitFutureDates: false,
                        selectedTimeFrame: "view._getSelectedTimeFrame",
                        pastLimitDate: "view._getPastLimitDate"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            _initialize: function(options) {
                this.eventModel = options.eventModel;
                this.specialOccasionModel = options.specialOccasionModel;
                this.channel = options.channel;
            },

            _onRender: function() {
                this._bindEvents();
            },

            _bindEvents: function() {
                this.listenTo(this.uiComponents.timeFrame, "TimeFrameView:Save", this._onTimeFrameSave);
                this.listenTo(this.uiComponents.timeFrame, "TimeFrameView:Cancel", this._closeTimeFrameComponent);
                this.listenTo(this, "dialog:closeButtonClick", this._closeTimeFrameComponent);
            },

            _getSelectedTimeFrame: function() {
                var startDate = this.eventModel.isNew() ? new Date() : this.eventModel.getStartDate();
                var endDate = this.eventModel.isNew() ? new Date() : this.eventModel.getEndDate();
                var selectedTimeFrame = {
                    startDate: DateUtility.date2Str(startDate, true),
                    expirationDate: DateUtility.date2Str(endDate, true)
                };
                return selectedTimeFrame;
            },

            _getPastLimitDate: function() {
                var today = new Date();
                var limitDate = ScheduleUtilities.incrementDateByDays(today, -1); //Taking a day before because the timezone can cause us that..(LE-92574)

                if (!this.eventModel.isNew()) {
                    var startDate = this.eventModel.getStartDate();

                    if (startDate < limitDate) {
                        limitDate = startDate;
                    }
                }

                return limitDate;
            },

            _onTimeFrameSave: function(timeFrame) {
                this.trigger("SpecialOccasionEventTimeFrameView:save", timeFrame);
            },

            _closeTimeFrameComponent: function() {
                this.trigger("SpecialOccasionEventTimeFrameView:close");
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionEventTimeFrameView;
});
